import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UserDetailsForumComponent, DialogExampleBadge } from './user-details-forum/user-details-forum.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { GoogleLocationFinderComponent } from './google-location-finder/google-location-finder.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CheckoutFormComponent } from './checkout-form/checkout-form.component';
import { MatStepperModule } from '@angular/material/stepper';
import { NgxPaymentCardModule } from 'ngx-payment-card';
import { HttpClientModule } from '@angular/common/http';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { ThreeDsAuthenticationComponent } from './three-ds-authentication/three-ds-authentication.component';
//import for GooglePlaceModule
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
 
@NgModule({
  declarations: [
    AppComponent,
    UserDetailsForumComponent,
    CheckoutComponent,
    GoogleLocationFinderComponent,
    DialogExampleBadge,
    CheckoutFormComponent,
    ThreeDsAuthenticationComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatIconModule,
    MatButtonModule,
    MatBadgeModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatStepperModule,
    NgxPaymentCardModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    GooglePlaceModule
  ],
  entryComponents: [UserDetailsForumComponent, DialogExampleBadge],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }